export interface Pago {
  pagoId: number;
  pagoLabel: string;
  gastoIdFkEnPagos: string;
  concepto: string;
  importe: number;
  fechaDeCarga: string;
  factura: File | string | null;
  documento: File | string | null;
  aclaracion: string;
  comprobante: File | string | null;
  estado: string;
  caja: string;
  fechadepago: Date | string | null;
  usuario: string;
  categoria: string;
  proceso: string;
  gasto?: string;
}

export const pagoInicial: Pago = {
  pagoId: 1,
  pagoLabel: '',
  gastoIdFkEnPagos: '',
  concepto: '',
  importe: 0,
  fechaDeCarga: '',
  factura: null,
  documento: null,
  aclaracion: '',
  comprobante: null,
  estado: '',
  caja: '',
  fechadepago: new Date(),
  usuario: '',
  categoria: '',
  proceso: '',
  gasto: ''
};
